<template>
    <div>
        <breadcrumb :routerList="[{to:'/yuce/wxhuizong',title:'外销列表'},{title:'外销列表(详情)'}]"/>
        <div class="h-content">
            <div class="h-row h-mrt0">
                <div class="h-rowIn">
                    <div class="h-rowBox">
                        <el-form :model="f" label-position="right" ref="f" :inline="true" :rules="rules"
                                 class="demo-ruleForm h-formbLine h-formbLine1">
                            <div class="h-rowCon">

                                <div class="h-pieceIn2">
                                    <div class="h-pieceTitle2" style="margin-bottom: 0.3rem;">
                                        <h1>预测信息</h1>
                                    </div>
                                    <div class="h-pieceCon2">
                                        <div class="h-formLine Yangbiao">
                                            <el-form-item label="预测编码" class="h-elformWrap-2">
                                                <el-input class="h-tableInput" v-model="saveData.id" disabled></el-input>
                                            </el-form-item>
                                            <el-form-item label="国家名称" class="h-elformWrap-2">
                                                <brselect placeholder="请选择"
                                                          category="YLCountry_agent"
                                                          :v="saveData.country"
                                                          disabled
                                                          clearable
                                                          v-model="saveData.country">
                                                </brselect>
                                            </el-form-item>
                                            <el-form-item label="产品编码" class="h-elformWrap-2" required="">
                                                <el-select class="h-tableInput" filterable v-model="saveData.productCode"  disabled="" :filter-method="dataFilter" @change="selectCode(1)">
                                                    <el-option v-for="(item,index) in pCode" :key="index" :label="item" :value="item">
                                                    </el-option>
                                                </el-select>
                                            </el-form-item>
                                            <el-form-item label="产品型号" class="h-elformWrap-2">
                                                <el-select class="h-tableInput" filterable  v-model="saveData.productModel"disabled=""  >
                                                    <el-option v-for="(item,index) in pModel" :key="index" :label="item" :value="item">
                                                    </el-option>
                                                </el-select>
                                            </el-form-item>
                                            <el-form-item label="产地" class="h-elformWrap-2" required="">
                                                <el-input class="h-tableInput" v-model="saveData.factory" disabled="true"></el-input>
                                            </el-form-item>
                                            <el-form-item label="规格型号" class="h-elformWrap-2" required="">
                                                <el-input placeholder="请输入..." class="h-tableInput" v-model="saveData.oemDesc" disabled="true"></el-input>
                                            </el-form-item>
                                            <el-form-item label="数量" class="h-elformWrap-2" required="">
                                                <el-input v-model="saveData.proNumber" placeholder="产品数量" class="h-tableInput" disabled=""
                                                          onkeyup="if(this.value.length==1){this.value=this.value.replace(/[^1-9]/g,'')}else{this.value=this.value.replace(/\D/g,'')}">
                                                </el-input>
                                            </el-form-item>
                                            <el-form-item label="发货方式" class="h-elformWrap-2" required="">
                                                <el-select class="h-tableInput" v-model="saveData.deliveryMethod" disabled="">
                                                    <el-option value="1" label="直发"></el-option>
                                                    <el-option value="2" label="库发"></el-option>
                                                </el-select>
                                            </el-form-item>
                                            <el-form-item label="是否实单" class="h-elformWrap-2" required="">
                                                <el-select class="h-tableInput" v-model="saveData.isReal" disabled="">
                                                    <el-option value="1" label="实单"></el-option>
                                                    <el-option value="0" label="备货"></el-option>
                                                </el-select>
                                            </el-form-item>
                                            <el-form-item label="预计交货时间" class="h-elformWrap-2">
                                                <el-date-picker v-model="saveData.deliveryDate" type="date" :clearable="false"
                                                                class="h-tableInput" disabled=""
                                                                value-format="yyyy-MM-dd" :placeholder="saveData.deliveryDate"
                                                                placeholder="请选择日期" :picker-options="pickerOptions">
                                                </el-date-picker>
                                            </el-form-item>
                                            <el-form-item label="备注" class="h-elformWrap-2">
                                                <el-input v-model="saveData.remark" placeholder="备注" class="h-tableInput" disabled=""></el-input>
                                            </el-form-item>
                                            <el-form-item v-if="saveData.isLk == 1" prop="fileUrl" label="方案图纸" class="h-elformWrap-2"  :rules="this.lkFlag ?rules.fileUrl:[{ required: false, message: '请上传附件', trigger: 'blur' }]">
                                                <brupload
                                                        v-model="fileUrl"
                                                        :refid=saveData.id
                                                        reftype="WXYC_LKFJ"
                                                        :limit="1"
                                                        :showtime="false"
                                                        delflag>
                                                </brupload>
                                            </el-form-item>
                                            <el-form-item v-if="saveData.isLk == 1" prop="fileUrl" label="施工确认单" class="h-elformWrap-2"  :rules="this.lkFlag ?rules.fileUrl:[{ required: false, message: '请上传附件', trigger: 'blur' }]">
                                                <brupload
                                                        v-model="fileUrl"
                                                        :refid=saveData.id
                                                        reftype="WXYC_SGQRD"
                                                        :limit="1"
                                                        :showtime="false"
                                                        delflag>
                                                </brupload>
                                            </el-form-item>
                                            <el-form-item label="海尔标准配置" class="h-elformWrap-2" required="" v-if="saveData.isLk == 1">
                                                <el-select class="h-tableInput" v-model="saveData.isStandard" disabled="">
                                                    <el-option value="1" label="是"></el-option>
                                                    <el-option value="2" label="否"></el-option>
                                                </el-select>
                                            </el-form-item>
                                            <el-form-item v-if="saveData.receivingAddress != null && saveData.receivingAddress != ''" label="收货地址" class="h-elformWrap-2" prop="receivingAddress">
                                                <el-input readonly v-model="saveData.receivingAddress"
                                                          :title="saveData.receivingAddress">
                                                </el-input>
                                            </el-form-item>
                                            <el-form-item v-if="saveData.isLk == 1 " prop="fileUrl" label="投标参数" class="h-elformWrap-2"  :rules="this.lkFlag ?rules.fileUrl:[{ required: false, message: '请上传附件', trigger: 'blur' }]">
                                                <brupload
                                                        v-model="fileUrl"
                                                        :refid=saveData.id
                                                        reftype="WXYC_TBCS"
                                                        :limit="1"
                                                        :showtime="false"
                                                        delflag>
                                                </brupload>
                                            </el-form-item>
                                            <el-form-item label="常规或改制" class="h-elformWrap-2" required="">
                                                <brselect category="shifou_dingzhi" :v="saveData.isSpecific" disabled=""
                                                          v-model="saveData.isSpecific" placeholder="请选择"
                                                          @change="changes()" class="h-tableInput"/>
                                            </el-form-item>
                                            <el-form-item label="改制大类" class="h-elformWrap-2" required="" v-if="saveData.isSpecific == '2' && saveData.specific && !newFlag">
                                                <el-input v-if="saveData.isSpecific == 1" v-model="saveData.specific"
                                                          disabled=""
                                                          class="h-tableInput" placeholder="描述"></el-input>
                                                <el-select v-else v-model="saveData.specific" placeholder="请选择"
                                                           style="width: 100%;" class="h-tableInput" @change="addspecificId()"
                                                           :multiple="true" disabled=""
                                                           clearable filterable>
                                                    <el-option v-for="(item,index) in describe" :key="item.specificId" :label="item.des"
                                                               :value="item.des">
                                                    </el-option>
                                                </el-select>
                                            </el-form-item>
                                            <el-form-item label="改制要求" class="h-elformWrap-2" v-if="saveData.isSpecific == '2' && saveData.specificReform">
                                                <el-input v-model="saveData.specificReform"
                                                          disabled=""
                                                          placeholder="改制要求"
                                                          class="h-tableInput">
                                                </el-input>
                                            </el-form-item>
                                            <el-form-item label="总单台加价(元)" class="h-elformWrap-2" v-if="saveData.isSpecific == '2'">
                                                <el-input placeholder="请输入..." v-model="saveData.reformPriceRmb" disabled=""></el-input>
                                            </el-form-item>
                        <!--                    <el-form-item label="预排单号" class="h-elformWrap-2" v-if="saveData.protype=='自产' && (saveData.isOther == '' || saveData.isOther == null)">
                                                <el-select v-model="saveData.ypIds" clearable allow-create filterable
                                                           class="h-tableInput" :multiple="true" @change="getYbTable" disabled="">
                                                    <el-option v-for="(item, index) in getypData" :key="index" :label="item.id"
                                                               :value="item.id">
                                                    </el-option>
                                                </el-select>
                                            </el-form-item>-->
                                            <el-form-item label="预排单号" class="h-elformWrap-2"  v-if="saveData.protype=='自产' && (saveData.isOther == '' || saveData.isOther == null)">
                                                <el-input class="h-tableInput" v-model="saveData.ypIds" disabled="true"></el-input>
                                            </el-form-item>
                                            <el-form-item label="占用预测单类型" class="h-elformWrap-2" v-if="saveData.isSpecific=='2' && (saveData.ypIds == '' || saveData.ypIds == null)">
                                                <el-select class="h-tableInput" v-model="saveData.isOther" @change="isYp(1)" disabled="">
                                                    <el-option value="" label=""></el-option>
                                                    <el-option value="1" label="自己"></el-option>
                                                    <el-option value="2" label="他人"></el-option>
                                                </el-select>
                                            </el-form-item>
                                            <el-form-item label="使用已预测单号" class="h-elformWrap-2" v-if="saveData.isOther=='1' && saveData.isSpecific=='2' && (saveData.ypIds == '' || saveData.ypIds == null)">
                                                <el-input class="h-tableInput" v-model="saveData.useId" disabled></el-input>
                                            </el-form-item>
                                            <el-form-item label="使用他人已预测单号" class="h-elformWrap-2" v-if="saveData.isOther=='2' && saveData.isSpecific=='2' && (saveData.isScheduling == '' || saveData.isScheduling == null)">
                                                <el-input class="h-tableInput" v-model="saveData.otherUseId" disabled></el-input>
                                            </el-form-item>
                                            <el-form-item label="占用改制加价(元)" class="h-elformWrap-2" v-if="saveData.isSpecific == '2'">
                                                <el-input placeholder="请输入..." v-model="saveData.otherYcReformPrice" disabled=""></el-input>
                                            </el-form-item>
                                            <el-form-item label="改制类型" class="h-elformWrap-2" required=""  v-if="saveData.isSpecific=='2' ">
                                                <el-select class="h-tableInput" v-model="saveData.isReformStock" disabled>
                                                    <el-option value="0" label="生产改制"></el-option>
                                                    <el-option value="1" label="库存改制"></el-option>
                                                </el-select>
                                            </el-form-item>
                                            <el-form-item label="生产版本" class="h-elformWrap-2" prop="reformEdition" v-if="saveData.isSpecific=='2' ">
                                                <brselect disabled category="gaizhi_edition_wx" :v="saveData.reformEdition" disabled v-model="saveData.reformEdition"/>
                                            </el-form-item>
                                            <el-form-item label="生产日期" class="h-elformWrap-2" v-if="saveData.isSpecific=='2'">
                                                <el-input class="h-tableInput" v-model="saveData.produceTime" disabled></el-input>
                                            </el-form-item>
                                            <div style="margin-top: 10px;" v-if="saveData.isSpecific == '2'">

                                                <div v-for="(listIt, index) in saveData.specificList" :key="index" class="h-formBox">

                                                    <el-form-item  class="h-elformWrap-3" >
                                                        <template slot="label">
                                                            改制目录{{index+1}}
                                                        </template>
                                                        <el-input  v-model="saveData.specificList[index].specificDivision" readonly ></el-input>
                                                    </el-form-item>
                                                    <el-form-item  class="h-elformWrap-3" >
                                                        <template slot="label">
                                                            改制要求{{index+1}}
                                                        </template>
                                                        <el-input  v-model="saveData.specificList[index].specificReform" readonly ></el-input>
                                                    </el-form-item>
                                                    <el-form-item  class="h-elformWrap-3" >
                                                        <template slot="label">
                                                            改制备注{{index+1}}
                                                        </template>
                                                        <el-input type="textarea" autosize v-model="saveData.specificList[index].specificRemark" readonly ></el-input>
                                                    </el-form-item>
                                                    <el-form-item  class="h-elformWrap-3" >
                                                        <template slot="label">
                                                            单台改制数量{{index+1}}
                                                        </template>
                                                        <el-input placeholder="请输入改制数量" v-model="saveData.specificList[index].reformNum" readonly></el-input>
                                                    </el-form-item>
                                                    <el-form-item  class="h-elformWrap-3" >
                                                        <template slot="label">
                                                            单台加价{{index+1}}
                                                        </template>
                                                        <el-input placeholder="单台加价" v-model="saveData.specificList[index].reformPrice" readonly></el-input>
                                                    </el-form-item>
                                                </div>
                                                <div class="N-chan"  v-if="showSpecifictDetail">
                                                    <div class="h-pieceTitle2">
                                                        <h1>改制确认</h1>
                                                    </div>
                                                    <div class="h-pieceCon2">
                                                        <div class="h-formLine Yangbiao">
                                                            <el-form-item label="产值(元)" class="h-elformWrap-2" prop="outputValue">
                                                                <el-input v-model="saveData.outputValue" placeholder="请输入" readonly>
                                                                </el-input>
                                                            </el-form-item>
                                                            <el-form-item label="标准台" class="h-elformWrap-2" prop="standardTable">
                                                                <el-input v-model="saveData.standardTable" placeholder="请输入" readonly>
                                                                </el-input>
                                                            </el-form-item>
                                                        </div>
                                                    </div>
                                                    <div class="h-pieceCon2">
                                                        <div class="h-formLine Yangbiao">
                                                            <div v-for="(listIt, index) in saveData.individualizeList" :key="index" class="h-formBox">
                                                                <el-form-item  class="h-elformWrap-35" >
                                                                    <template slot="label">
                                                                        个性化定制标准描述{{index+1}}
                                                                    </template>
                                                                    <el-input placeholder="由型号经理填写" v-model="saveData.individualizeList[index]" readonly></el-input>
                                                                </el-form-item>
                                                            </div>
                                                        </div>
                                                    </div>
                                                    <div class="h-pieceCon2">
                                                        <div class="h-formLine Yangbiao">
                                                            <div v-for="(listIt, index) in saveData.logoRequestList" :key="index" class="h-formBox">
                                                                <el-form-item  class="h-elformWrap-35" >
                                                                    <template slot="label">
                                                                        包装标识要求{{index+1}}
                                                                    </template>
                                                                    <el-input placeholder="由型号经理填写" v-model="saveData.logoRequestList[index]" readonly></el-input>
                                                                </el-form-item>
                                                            </div>
                                                        </div>
                                                    </div>


                                                    <div class="h-pieceCon2">
                                                        <div class="h-formLine Yangbiao">
                                                            <el-form-item label="物料工位" class="h-elformWrap-5" prop="stationlist" >
                                                                <el-checkbox-group v-model="saveData.stationlist" disabled>
                                                                    <el-checkbox v-for="item in options" :label="item.code" :key="item.code" >{{item.name}}</el-checkbox>
                                                                </el-checkbox-group>
                                                            </el-form-item>
                                                            <el-form-item label="检测要求" class="h-elformWrap-5" prop="checkRequest">
                                                                <el-input type="textarea" placeholder="请输入检测要求" autosize v-model="saveData.checkRequest" readonly></el-input>
                                                            </el-form-item>
                                                            <el-form-item label="涉及主关件变更的测试计划及测试报告" class="h-elformWrap-5">
                                                                <brupload
                                                                        :refid="saveData.id"
                                                                        reftype="改制明细测试报告"
                                                                        :uploadflag="false"
                                                                        :delflag="false"
                                                                        :showtime="false"
                                                                >
                                                                </brupload>
                                                            </el-form-item>
                                                        </div>
                                                    </div>

                                                </div>

                                                <el-table
                                                        ref="multipleTable"
                                                        :data="saveData.reformMainDetailList"
                                                        border
                                                        v-if="showSpecifictDetail"
                                                        style="width: 100%">
                                                    <el-table-column label="个性化改制物料明细">
                                                        <el-table-column
                                                                prop="orderby"
                                                                label="序号"
                                                                width="50">
                                                            <template slot-scope="scope">
                                                                {{scope.row.orderby}}
                                                            </template>
                                                        </el-table-column>
                                                        <el-table-column
                                                                prop="materialName"
                                                                label="物料描述"
                                                                :show-overflow-tooltip="true"
                                                                width="130">
                                                            <template slot-scope="scope">
                                                                <div>
                                                                    {{scope.row.materialName}}
                                                                </div>
                                                            </template>
                                                        </el-table-column>
                                                        <el-table-column
                                                                prop="materialCode"
                                                                label="物料专用号"
                                                                width="90">
                                                            <template slot-scope="scope">
                                                                <div>
                                                                    {{scope.row.materialCode}}
                                                                </div>
                                                            </template>
                                                        </el-table-column>
                                                        <el-table-column
                                                                prop="purchaseGroup"
                                                                label="采购组"
                                                                width="80">
                                                            <template slot-scope="scope">
                                                                {{scope.row.purchaseGroup}}
                                                            </template>
                                                        </el-table-column>
                                                        <el-table-column
                                                                prop="materialOrder"
                                                                label="物料单耗"
                                                                width="50">
                                                            <template slot-scope="scope">
                                                                <div>
                                                                    {{scope.row.materialOrder}}
                                                                </div>
                                                            </template>
                                                        </el-table-column>
                                                        <el-table-column
                                                                prop="unit"
                                                                label="单位"
                                                                width="50">
                                                            <template slot-scope="scope">
                                                                <div>
                                                                    {{scope.row.unit}}
                                                                </div>
                                                            </template>
                                                        </el-table-column>
                                                        <el-table-column
                                                                prop="numbermb"
                                                                label="模板导入数量"
                                                                width="50">
                                                            <template slot-scope="scope">
                                                                <div>
                                                                    {{scope.row.numbermb}}
                                                                </div>
                                                            </template>
                                                        </el-table-column>
                                                        <el-table-column
                                                                prop="numberjs"
                                                                label="系统计算数量"
                                                                width="50">
                                                            <template slot-scope="scope">
                                                                <div>
                                                                    {{scope.row.numberjs}}
                                                                </div>
                                                            </template>
                                                        </el-table-column>
                                                        <el-table-column
                                                                prop="number"
                                                                label="最终使用数量"
                                                                width="50">
                                                            <template slot-scope="scope">
                                                                <div>
                                                                    {{scope.row.number}}
                                                                </div>
                                                            </template>
                                                        </el-table-column>
                                                        <el-table-column
                                                                prop="isSelf"
                                                                label="自制/外购"
                                                                width="90"
                                                                :show-overflow-tooltip="true">
                                                            <template slot-scope="scope">
                                                                <div>
                                                                    <div v-if="scope.row.isSelf == 0">外购</div>
                                                                    <div v-if="scope.row.isSelf == 1">自制</div>
                                                                    <div v-if="scope.row.isSelf == 2">外购-厂家改制</div>
                                                                    <div v-if="scope.row.isSelf == 3">外购-到厂改制</div>
                                                                </div>
                                                            </template>
                                                        </el-table-column>


                                                        <el-table-column
                                                                prop="remark"
                                                                label="备注"
                                                                :show-overflow-tooltip="true"
                                                                width="200">
                                                            <template slot-scope="scope">
                                                                <div>
                                                                    {{scope.row.remark}}
                                                                </div>
                                                            </template>
                                                        </el-table-column>

                                                        <el-table-column
                                                                prop="supplierName"
                                                                label="供应商名称"
                                                                :show-overflow-tooltip="true"
                                                                width="200">
                                                            <template slot-scope="scope">
                                                                <div>
                                                                    {{scope.row.supplierName}}
                                                                </div>
                                                            </template>
                                                        </el-table-column>

                                                        <el-table-column
                                                                label="图纸"
                                                                :show-overflow-tooltip="true"
                                                                fixed
                                                                min-width="150">
                                                            <template slot-scope="scope">
                                                                <brupload
                                                                        :refid="scope.row.id"
                                                                        reftype="改制物料明细"
                                                                        :showtime="false">
                                                                </brupload>
                                                            </template>
                                                        </el-table-column>

                                                        <el-table-column
                                                                prop="changeDes"
                                                                label="变更描述"
                                                                :show-overflow-tooltip="true"
                                                                width="200">
                                                            <template slot-scope="scope">
                                                                <div>
                                                                    {{scope.row.changeDes}}
                                                                </div>
                                                            </template>
                                                        </el-table-column>

                                                    </el-table-column>
                                                    <el-table-column label="替换物料明细">
                                                        <el-table-column
                                                                prop="materialNameTh"
                                                                label="物料描述"
                                                                :show-overflow-tooltip="true"
                                                                width="130">
                                                            <template slot-scope="scope">
                                                                <div>
                                                                    {{scope.row.materialNameTh}}
                                                                </div>
                                                            </template>
                                                        </el-table-column>
                                                        <el-table-column
                                                                prop="materialCodeTh"
                                                                label="物料专用号"
                                                                width="90">
                                                            <template slot-scope="scope">
                                                                <div>
                                                                    {{scope.row.materialCodeTh}}
                                                                </div>
                                                            </template>
                                                        </el-table-column>
                                                        <el-table-column
                                                                prop="unitTh"
                                                                label="单位"
                                                                width="50">
                                                            <template slot-scope="scope">
                                                                <div>
                                                                    {{scope.row.unitTh}}
                                                                </div>
                                                            </template>
                                                        </el-table-column>
                                                      <!--  <el-table-column
                                                                prop="numbermbTh"
                                                                label="模板导入数量"
                                                                width="90">
                                                            <template slot-scope="scope">
                                                                <el-input v-model="scope.row.numbermbTh" @change="changeMb(scope.row)" placeholder="数量"></el-input>
                                                            </template>
                                                        </el-table-column>
                                                        <el-table-column
                                                                prop="numberjsTh"
                                                                label="系统计算数量"
                                                                width="90">
                                                            <template slot-scope="scope">
                                                                <el-input v-model="scope.row.numberjsTh" disabled placeholder="数量"></el-input>
                                                            </template>
                                                        </el-table-column>-->
                                                        <el-table-column
                                                                prop="numberTh"
                                                                label="最终使用数量"
                                                                width="50">
                                                            <template slot-scope="scope">
                                                                <div>
                                                                    {{scope.row.numberTh}}
                                                                </div>
                                                            </template>
                                                        </el-table-column>

                                                        <el-table-column
                                                                prop="remarkTh"
                                                                label="备注"
                                                                :show-overflow-tooltip="true"
                                                                width="200">
                                                            <template slot-scope="scope">
                                                                <div>
                                                                    {{scope.row.remarkTh}}
                                                                </div>
                                                            </template>
                                                        </el-table-column>

                                                        <el-table-column
                                                                prop="supplierNameTh"
                                                                label="供应商名称"
                                                                :show-overflow-tooltip="true"
                                                                width="200">
                                                            <template slot-scope="scope">
                                                                <div>
                                                                    {{scope.row.supplierNameTh}}
                                                                </div>
                                                            </template>
                                                        </el-table-column>

                                                        <el-table-column
                                                                label="图纸"
                                                                :show-overflow-tooltip="true"
                                                                fixed
                                                                min-width="150">
                                                            <template slot-scope="scope">
                                                                <brupload
                                                                        :refid="scope.row.id"
                                                                        reftype="替换物料明细"
                                                                        :showtime="false">
                                                                </brupload>
                                                            </template>
                                                        </el-table-column>

                                                    </el-table-column>
                                                </el-table>
                                            </div>
                                            <div v-if="ycTable.length > 0" style="width: 95%">
                                                <div class="h-pieceTitle2">
                                                    <h1>占用预测库存信息</h1>
                                                </div>
                                                <el-table
                                                        ref="multipleTable"
                                                        :data="ycTable"
                                                        stripe
                                                        border
                                                        max-height="500"
                                                        style="width: 100%;margin-left: 2%">
                                                    <el-table-column
                                                            type="index"
                                                            width="40"
                                                            label="#">
                                                    </el-table-column>
                                                    <el-table-column
                                                            prop="id"
                                                            width="160"
                                                            :show-overflow-tooltip="true"
                                                            label="预测编码">
                                                    </el-table-column>
                                                    <el-table-column
                                                            prop="country"
                                                            width="90"
                                                            :show-overflow-tooltip="true"
                                                            label="国家名称">
                                                        <template slot-scope="scope">
                                                            <dictname category="YLCountry_agent"  :v="scope.row.country"/>
                                                        </template>
                                                    </el-table-column>
                                                    <el-table-column
                                                            prop="proModel"
                                                            width="140"
                                                            :show-overflow-tooltip="true"
                                                            label="型号">
                                                    </el-table-column>
                                                    <el-table-column
                                                            prop="proCode"
                                                            width="120"
                                                            :show-overflow-tooltip="true"
                                                            label="产品编码">
                                                    </el-table-column>
                                                    <el-table-column
                                                            prop="protype"
                                                            width="90"
                                                            label="型号属性"
                                                            :show-overflow-tooltip="true">
                                                    </el-table-column>
                                                    <el-table-column
                                                            prop="proNumber"
                                                            width="60"
                                                            :show-overflow-tooltip="true"
                                                            label="数量">
                                                    </el-table-column>
                                                    <el-table-column
                                                            prop="useNumber"
                                                            :show-overflow-tooltip="true"
                                                            width="100"
                                                            label="可录单数量">
                                                    </el-table-column>
                                                    <el-table-column
                                                            prop="useInventory"
                                                            width="120"
                                                            :show-overflow-tooltip="true"
                                                            label="使用库存数量">
                                                    </el-table-column>
                                                    <el-table-column
                                                            prop="stockStatus"
                                                            width="90"
                                                            label="库存状态">
                                                        <template slot-scope="scope">
                                                            <dictname category="kucun_status"  :v="scope.row.stockStatus"/>
                                                        </template>
                                                    </el-table-column>
                                                    <el-table-column
                                                            prop="isSpecific"
                                                            width="110"
                                                            :show-overflow-tooltip="true"
                                                            label="常规或改制">
                                                        <template slot-scope="scope">
                                                            <dictname category="shifou_dingzhi"  :v="scope.row.isSpecific"/>
                                                        </template>
                                                    </el-table-column>
                                                    <el-table-column
                                                            prop="reformPriceRmb"
                                                            :show-overflow-tooltip="true"
                                                            min-width="90"
                                                            label="总单台加价(元)">
                                                        <template slot-scope="scope">
                                                            <div style="text-align: left;">{{scope.row.reformPriceRmb}}</div>
                                                        </template>
                                                    </el-table-column>
                                                    <el-table-column
                                                            prop="specificReform"
                                                            :show-overflow-tooltip="true"
                                                            min-width="180"
                                                            label="改制要求">
                                                        <template slot-scope="scope">
                                                            <div style="text-align: left;">{{scope.row.specificReform}}</div>
                                                        </template>
                                                    </el-table-column>
                                                    <el-table-column
                                                            prop="remark"
                                                            :show-overflow-tooltip="true"
                                                            min-width="180"
                                                            label="备注">
                                                        <template slot-scope="scope">
                                                            <div style="text-align: left;">
                                                                {{scope.row.remark}}
                                                            </div>
                                                        </template>
                                                    </el-table-column>
                                                    <el-table-column
                                                            prop="cuname"
                                                            width="90"
                                                            label="创建人">
                                                    </el-table-column>
                                                </el-table>
                                            </div>
                                            <div v-if="OtherTable.length > 0" style="width: 95%">
<!--                                                <label style="font-size: 14px;margin-left: 20px;">占用他人预测库存信息</label>-->
                                                <div class="h-pieceTitle2">
                                                    <h1>占用他人预测库存信息</h1>
                                                </div>
                                                <el-table
                                                        ref="multipleTable"
                                                        :data="OtherTable"
                                                        stripe
                                                        border
                                                        max-height="500"
                                                        style="width: 100%;margin-left: 2%">
                                                    <el-table-column
                                                            type="index"
                                                            width="40"
                                                            label="#">
                                                    </el-table-column>
                                                    <el-table-column
                                                            prop="id"
                                                            width="160"
                                                            :show-overflow-tooltip="true"
                                                            label="预测编码">
                                                    </el-table-column>
                                                    <el-table-column
                                                            prop="country"
                                                            width="90"
                                                            :show-overflow-tooltip="true"
                                                            label="国家名称">
                                                        <template slot-scope="scope">
                                                            <dictname category="YLCountry_agent"  :v="scope.row.country"/>
                                                        </template>
                                                    </el-table-column>
                                                    <el-table-column
                                                            prop="proModel"
                                                            width="140"
                                                            :show-overflow-tooltip="true"
                                                            label="型号">
                                                    </el-table-column>
                                                    <el-table-column
                                                            prop="proCode"
                                                            width="120"
                                                            :show-overflow-tooltip="true"
                                                            label="产品编码">
                                                    </el-table-column>
                                                    <el-table-column
                                                            prop="protype"
                                                            width="90"
                                                            label="型号属性"
                                                            :show-overflow-tooltip="true">
                                                    </el-table-column>
                                                    <el-table-column
                                                            prop="proNumber"
                                                            width="60"
                                                            :show-overflow-tooltip="true"
                                                            label="数量">
                                                    </el-table-column>
                                                    <el-table-column
                                                            prop="useNumber"
                                                            :show-overflow-tooltip="true"
                                                            width="100"
                                                            label="可录单数量">
                                                    </el-table-column>
                                                    <el-table-column
                                                            prop="useInventory"
                                                            width="120"
                                                            :show-overflow-tooltip="true"
                                                            label="使用库存数量">
                                                    </el-table-column>
                                                    <el-table-column
                                                            prop="isSpecific"
                                                            width="110"
                                                            :show-overflow-tooltip="true"
                                                            label="常规或改制">
                                                        <template slot-scope="scope">
                                                            <dictname category="shifou_dingzhi"  :v="scope.row.isSpecific"/>
                                                        </template>
                                                    </el-table-column>
                                                    <el-table-column
                                                            prop="reformPriceRmb"
                                                            :show-overflow-tooltip="true"
                                                            min-width="90"
                                                            label="总单台加价(元)">
                                                        <template slot-scope="scope">
                                                            <div style="text-align: left;">{{scope.row.reformPriceRmb}}</div>
                                                        </template>
                                                    </el-table-column>
                                                    <el-table-column
                                                            prop="specificReform"
                                                            :show-overflow-tooltip="true"
                                                            min-width="180"
                                                            label="改制要求">
                                                        <template slot-scope="scope">
                                                            <div style="text-align: left;">{{scope.row.specificReform}}</div>
                                                        </template>
                                                    </el-table-column>
                                                    <el-table-column
                                                            prop="remark"
                                                            :show-overflow-tooltip="true"
                                                            min-width="180"
                                                            label="备注">
                                                        <template slot-scope="scope">
                                                            <div style="text-align: left;">
                                                                {{scope.row.remark}}
                                                            </div>
                                                        </template>
                                                    </el-table-column>
                                                    <el-table-column
                                                            prop="stockStatus"
                                                            width="90"
                                                            label="库存状态">
                                                        <template slot-scope="scope">
                                                            <dictname category="kucun_status"  :v="scope.row.stockStatus"/>
                                                        </template>
                                                    </el-table-column>
                                                    <el-table-column
                                                            prop="cuname"
                                                            width="90"
                                                            label="创建人">
                                                    </el-table-column>
                                                </el-table>
                                            </div>
                                            <div v-if="ybTable.length > 0" style="width: 95%">
                                                <div class="h-pieceTitle2">
                                                    <h1>占用预排信息</h1>
                                                </div>
                                                <el-table
                                                        ref="multipleTable"
                                                        :data="ybTable"
                                                        stripep
                                                        border
                                                        max-height="500"
                                                        style="width: 100%;margin-left: 2%">
                                                    <el-table-column
                                                            type="index"
                                                            width="40"
                                                            label="#">
                                                    </el-table-column>
                                                    <el-table-column
                                                            prop="id"
                                                            width="160"
                                                            :show-overflow-tooltip="true"
                                                            label="预测编码">
                                                    </el-table-column>
                                                    <el-table-column
                                                            prop="country"
                                                            width="90"
                                                            :show-overflow-tooltip="true"
                                                            label="国家名称">
                                                        <template slot-scope="scope">
                                                            <dictname category="YLCountry_agent"  :v="scope.row.country"/>
                                                        </template>
                                                    </el-table-column>
                                                    <el-table-column
                                                            prop="proModel"
                                                            width="140"
                                                            :show-overflow-tooltip="true"
                                                            label="型号">
                                                    </el-table-column>
                                                    <el-table-column
                                                            prop="proCode"
                                                            width="160"
                                                            :show-overflow-tooltip="true"
                                                            label="产品编码">
                                                    </el-table-column>
                                                    <el-table-column
                                                            prop="protype"
                                                            width="90"
                                                            label="型号属性"
                                                            :show-overflow-tooltip="true">
                                                    </el-table-column>
                                                    <el-table-column
                                                            prop="proNumber"
                                                            width="60"
                                                            :show-overflow-tooltip="true"
                                                            label="数量">
                                                    </el-table-column>
                                                    <el-table-column
                                                            prop="useNumber"
                                                            :show-overflow-tooltip="true"
                                                            width="100"
                                                            label="剩余数量">
                                                    </el-table-column>
                                                    <el-table-column
                                                            prop="remark"
                                                            :show-overflow-tooltip="true"
                                                            min-width="180"
                                                            label="备注">
                                                        <template slot-scope="scope">
                                                            <div style="text-align: left;">
                                                                {{scope.row.remark}}
                                                            </div>
                                                        </template>
                                                    </el-table-column>
                                                    <el-table-column
                                                            prop="cuname"
                                                            label="创建人">
                                                    </el-table-column>
                                                </el-table>
                                            </div>
                                        </div>
                                    </div>
                                </div>
                            </div>
                        </el-form>
                    </div>
                    <div class="h-txtCenter h-mrt60">
                        <el-button class="h-btn h-bBtn h-bgwhite" v-if="!shenpiFlag" @click="backS">返回</el-button>
                        <el-button class="h-btn h-bBtn h-bgwhite" v-if="shenpiFlag" @click="backS1">返回</el-button>
                    </div>
                </div>
            </div>
        </div>
    </div>
</template>
<script>
    import ss from '../../../../api/SystemService';
    export default {
        data(){
            return{
                orderNumber:"",
                dialogFormVisible:false,
                submitData:[],
                describe: [
                    {
                        specificId: '1',
                        des: '更改电源线'
                    },
                    {
                        specificId: '2',
                        des: '更改铭牌'
                    },
                    {
                        specificId: '3',
                        des: '外箱加贴唛头等'
                    },
                    {
                        specificId: '4',
                        des: '更改说明书/售后手册/检测报告等'
                    },
                    {
                        specificId: '5',
                        des: '内销型号改外销'
                    },
                    {
                        specificId: '6',
                        des: '拆电池'
                    },
                    {
                        specificId: '7',
                        des: '冰排放水'
                    },
                    {
                        specificId: '8',
                        des: '更改外包装箱'
                    },
                    {
                        specificId: '9',
                        des: '增加USB'
                    },
                    {
                        specificId: '11',
                        des: '增加圆盘记录仪'
                    },
                    {
                        specificId: '0',
                        des: '目录外改制'
                    },
                    {
                        specificId: '12',
                        des: '电动门功能'
                    }
                ],
                ycTable:[],
                ycList:[],
                userRole: [],
                instid: '',
                showhistory: false,
                isYPdisabled:false,
                getypData:[],
                ybTable:[],
                disabledOther:false,
                getOtherData:[],
                OtherTable:[],
                ypDisabled:true,
                areaList:[],
                isCheck:false,
                saveData:{
                    area:null,
                    otherNumber:0,
                    ypNumber:0,
                    oneNumber:0,
                    otherUseIds:[],
                    useOtherData:[],
                    isOther:null,
                    isReal:null,
                    isScheduling:null,
                    ypIds:[],
                    preId:'',
                    deliveryMethod:'',
                    isReformStock:null,
                    // isShipDate:'',
                    // shippingDate:'',
                    proNumber:0,
                    proModel:'',
                    proCode:'',
                    country:'',
                    specificReform:'',
                    reformPriceRmb:'',
                    specific:[],
                    isSpecific:'',
                    protype:'',
                    remark:'',
                    deliveryDate:null,
                    codeOpt:[],
                    modelOpt:[],
                    uids:[],
                    useData:[],
                    isStandard: null,
                    factory:null,
                    otherUseId:null,
                    useId:null,
                    specificList:[{
                        specificId: '',//改制id
                        specificDivision: '',//改制目录
                        specificReform: '',//改制要求
                        reformPrice: '',//单台加价
                        specificType:'',////1目录内改制 2目录外外改制
                        reformNum:1,//改制数量
                        specificRemark:'',//改制备注
                    }],
                    //型号经理录入 （个性化定制标准描述）
                    individualizeList:[''],
                    //型号经理录入 (包装标识要求)
                    logoRequestList:[''],
                    reformType:null,
                    stationlist:[],
                    reformMainDetailList:[],
                    materialStation: '',
                    individualizeReform: '',
                    logoRequest:'',
                    produceTime:'',
                    checkRequest:'',
                    // 产值(元)
                    outputValue:null,
                    // 标准台
                    standardTable:null,
                },
                // 限制收货时间不让选择今天以前的
                pickerOptions: {
                    disabledDate(time) {
                        return time.getTime() < Date.now() - 24 * 60 * 60 * 1000
                    }
                },
                gjCo:[],
                f: {
                    productModel: '',
                    productCode: ''
                },
                pModel: [],
                pCode: [],
                pCodecopy: [],
                items: {},
                disabled:true,
                fileUrl: [],
                rules:{
                    fileUrl: [
                        { required: true, message: '请上传冷库附件', trigger: 'blur' }
                    ]
                },
                q:{
                    id:'',
                },
                showSpecifictDetail:false,
                shenpiFlag:false,
                newFlag:false,
                isshowtip:false,
            }
        },
        created() {
            this.saveData.isOther = "";
            this.saveData.isScheduling = "";
            this.shenpiFlag = this.$route.query.shenpi;
            //获取物料工位
            this.options = this.$store.getters.dictlist("material_station");
            this.query();
        },
        methods:{
            addNumber(){
                this.saveData.proNumber = 0;
                var num = 0;
                if(this.ycTable.length>0){
                    for(var i=0;i<this.ycTable.length;i++){
                        num += parseInt(this.ycTable[i].useNumber);
                    }
                }
                if(!this.saveData.otherNumber || this.saveData.otherNumber==null){
                    this.saveData.otherNumber =0;
                }
                this.saveData.proNumber = parseInt(this.saveData.otherNumber)+num;
                this.$forceUpdate();
            },
            ypRelease(){
                if(this.saveData.oneNumber > this.saveData.ypNumber){
                    this.ypDisabled = false
                }else {
                    this.ypDisabled = true
                }
            },
            getYbTable(){
                this.ybTable = [];
                var obj= {
                    proCode: this.saveData.proCode
                }
                ss.waixiao.selectCheckPreList(obj).then(rd => {
                    for(var i=0;i<this.saveData.ypIds.length;i++){
                        for(var t=0;t<rd.length;t++){
                            if(this.saveData.ypIds[i]==rd[t].id){
                                this.ybTable.push(rd[t]);
                            }
                        }
                    }
                })
            },
            submitFlage(data){
                this.tableData = [];
                this.tableData.push(this.saveData);
                var f = true;
                b:
                    if (f) {
                        var cou = this.$store.getters.dictlist("YLCountry_agent");
                        for (var i = 0; i < this.tableData.length; i++) {
                            for (var j = 0; j < cou.length; j++) {
                                if (cou[j].name == this.tableData[i].country) {
                                    this.tableData[i].country = cou[j].code
                                }
                            }
                            if (this.tableData[i].isSpecific == 2) {
                                //循环设置
                                this.tableData[i].specificReq = _.join(this.tableData[i].specific || [], ",");
                            } else {
                                this.tableData[i].specificId = '';
                                this.tableData[i].specificReq = '';
                            }

                            if (this.tableData[i].useData && this.tableData[i].useData != '') {
                                this.tableData[i].useMeg = _.join(this.tableData[i].useData || [], ",");
                                this.tableData[i].useId = _.join(this.tableData[i].useData || [], ",");
                            } else {
                                this.tableData[i].useId = '';
                                this.tableData[i].useMeg = '';
                            }

                            this.tableData[i].prolist = [];
                            this.tableData[i].modelOpt = [];
                            this.tableData[i].codeOpt = [];
                            this.tableData[i].preId = '';
                            this.tableData[i].otherUseId = '';
                            if (this.tableData[i].ypIds) {
                                this.tableData[i].preId = _.join(this.tableData[i].ypIds || [], ",");
                            }
                            if (this.tableData[i].useOtherData) {
                                this.tableData[i].otherUseId = _.join(this.tableData[i].useOtherData || [], ",");
                            }
                            if (!this.tableData[i].specificType || this.tableData[i].specificType == '') {
                                if (this.tableData[i].isSpecific == 1) {
                                    this.tableData[i].specificType = '1';
                                } else {
                                    var index = this.tableData[i].specificId.indexOf("0");
                                    if (index == -1) {
                                        this.tableData[i].specificType = '1';
                                    } else {
                                        this.tableData[i].specificType = '2';
                                    }
                                }
                            }
                            // if (this.tableData[i].otherUseId || this.tableData[i].otherUseId != null || this.tableData[i].otherUseId != "") {
                            //     var num = 0;
                            //     for (var y = 0; y < this.OtherTable.length; y++) {
                            //         num += this.OtherTable[y].useNumber;
                            //     }
                            //     if (this.tableData[i].otherNumber > num) {
                            //         return this.$msg.msge("借用他人数量不能大于所选借用他人预测可录单数量");
                            //     }
                            // }
                            // console.log(this.tableData[i].specificType,"????");
                        }
                    }
                if(data == '提交'){
                    this.subTo();
                }else {
                    this.saveTo();
                }
            },
            saveTo() {
                ss.waixiao.saveTo(this.tableData).then(rd => {
                    this.$msg.msgs(rd.msg);
                    this.dialogFormVisible = false;
                    this.$parent.query();
                })
            },
            subTo() {
                this.$msg.confirm("确认提交?", () => {
                    this.submitData = this.tableData;
                    if (this.submitData.length == 0) {
                        this.$msg.msge("数据不能为空,请填写数据!");
                    } else {
                        var f = true;
                        b:
                            if (f) {
                                var cou = this.$store.getters.dictlist("YLCountry_agent");
                                for (var i = 0; i < this.submitData.length; i++) {
                                    for (var j = 0; j < cou.length; j++) {
                                        if (cou[j].name == this.submitData[i].country) {
                                            this.submitData[i].country = cou[j].code
                                        }
                                    }
                                    if (this.submitData[i].isSpecific == 2) {
                                        //循环设置
                                        this.submitData[i].specificReq = _.join(this.submitData[i].specific || [], ",");
                                    } else {
                                        this.submitData[i].specificId = '';
                                        this.submitData[i].specificReq = '';
                                    }
                                    // if(!this.submitData[i].useMeg || this.submitData[i].useMeg == '' || this.submitData[i].useMeg == null){
                                    //     this.$msg.msg("第"+(i+1)+"行，预测单未选择")
                                    //     return
                                    // }
                                    this.submitData[i].prolist = [];
                                    this.submitData[i].modelOpt = [];
                                    this.submitData[i].codeOpt = [];

                                    if (!this.submitData[i].specificType || this.submitData[i].specificType == '') {
                                        if (this.submitData[i].isSpecific == 1) {
                                            this.submitData[i].specificType = '1';
                                        } else {
                                            var index = this.submitData[i].specificId.indexOf("0");
                                            if(index == -1){
                                                this.submitData[i].specificType = '1';
                                            }else{
                                                this.submitData[i].specificType = '2';
                                            }
                                        }
                                    }
                                    if(!this.submitData[i].country || this.submitData[i].country == '' || this.submitData[i].country == null){
                                        return this.$msg.msge("国家不能为空");
                                    }
                                    if(!this.submitData[i].area || this.submitData[i].area == '' || this.submitData[i].area == null){
                                        return this.$msg.msge("区域不能为空");
                                    }
                                    if(!this.submitData[i].proCode || this.submitData[i].proCode == '' || this.submitData[i].proCode == null){
                                        return this.$msg.msge("产品编码不能为空");
                                    }
                                    if(!this.submitData[i].proNumber || this.submitData[i].proNumber == '' || this.submitData[i].proNumber == null){
                                        return this.$msg.msge("数量不能为空");
                                    }
                                    if(!this.submitData[i].isSpecific || this.submitData[i].isSpecific == '' || this.submitData[i].isSpecific == null){
                                        return this.$msg.msge("常规或改制不能为空");
                                    }
                                    if(this.submitData[i].isSpecific == '2' || this.submitData[i].isSpecific == 2){
                                        if(!this.submitData[i].isReformStock || this.submitData[i].isReformStock == '' || this.submitData[i].isReformStock == null){
                                            return this.$msg.msge("改制类型不能为空");
                                        }
                                        if(!this.submitData[i].reformEdition || this.submitData[i].reformEdition == '' || this.submitData[i].reformEdition == null){
                                            return this.$msg.msge("生产版本不能为空");
                                        }
                                    }
                                    if(!this.submitData[i].isReal || this.submitData[i].isReal == '' || this.submitData[i].isReal == null){
                                        return this.$msg.msge("是否实单不能为空");
                                    }
                                    if(this.submitData[i].isReal == '1'){
                                        if(!this.submitData[i].deliveryDate || this.submitData[i].deliveryDate == '' || this.submitData[i].deliveryDate == null){
                                            return this.$msg.msge("预计交货时间不能为空");
                                        }
                                    }
                                    if(this.submitData[i].isScheduling == '1' || this.submitData[i].isScheduling == '2'){
                                        if(!this.submitData[i].ypIds || this.submitData[i].ypIds == '' || this.submitData[i].ypIds == null){
                                            return this.$msg.msge("预排单号不能为空");
                                        }
                                    }
                                    if(this.submitData[i].isOther == '1'){
                                        if(!this.submitData[i].useData || this.submitData[i].useData == '' || this.submitData[i].useData == null){
                                            return this.$msg.msge("预测单号不能为空");
                                        }
                                    }else if(this.submitData[i].isOther == '2'){
                                        if(!this.submitData[i].useOtherData || this.submitData[i].useOtherData == '' || this.submitData[i].useOtherData == null){
                                            return this.$msg.msge("他人预测单号不能为空");
                                        }
                                    }
                                    if(this.submitData[i].protype == 'OEM') {
                                        if(!this.submitData[i].deliveryMethod || this.submitData[i].deliveryMethod == '' || this.submitData[i].deliveryMethod == null){
                                            return this.$msg.msge("发货方式不能为空");
                                        }
                                    }
                                }
                                ////ss.waixiao.subTo(this.submitData).then(rd => {
                                //// 新版提交
                                ss.waixiao.submitNewTo(this.submitData).then(rd => {
                                    this.$msg.msgs(rd.msg);
                                    this.submitData = [];
                                    this.dialogFormVisible = false;
                                    this.$parent.query();
                                });
                            }
                    }
                })
            },
            addspecificId(v) {
                this.saveData.specificId = '';
                this.saveData.reformPriceRmb = '';
                if(this.saveData.specific){
                    for (var i = 0; i < this.saveData.specific.length; i++) {
                        for (var j = 0; j < this.describe.length; j++) {
                            if (this.saveData.specific[i] == this.describe[j].des) {
                                if (this.describe[j].specificId && this.describe[j].specificId != '') {
                                    if (this.saveData.specificId != null && this.saveData.specificId != '') {
                                        this.saveData.specificId = this.saveData.specificId + this.describe[j].specificId + ", "
                                    } else {
                                        this.saveData.specificId = this.describe[j].specificId + ", "
                                    }
                                }
                                if (this.describe[j].specificId == '9') {
                                    if (this.saveData.reformPriceRmb != null && this.saveData.reformPriceRmb != '') {
                                        this.saveData.reformPriceRmb = this.saveData.reformPriceRmb + 335;
                                    } else {
                                        this.saveData.reformPriceRmb = 335;
                                    }
                                } else if (this.describe[j].specificId == '11') {
                                    if (this.saveData.reformPriceRmb != null && this.saveData.reformPriceRmb != '') {
                                        this.saveData.reformPriceRmb = this.saveData.reformPriceRmb + 2010;
                                    } else {
                                        this.saveData.reformPriceRmb = 2010;
                                    }
                                } else if (this.describe[j].specificId == '12') {
                                    if (this.saveData.reformPriceRmb != null && this.saveData.reformPriceRmb != '') {
                                        this.saveData.reformPriceRmb = this.saveData.reformPriceRmb + 5440;
                                    } else {
                                        this.saveData.reformPriceRmb = 5440;
                                    }
                                } else {
                                    if (this.saveData.reformPriceRmb != null && this.saveData.reformPriceRmb != '') {
                                        this.saveData.reformPriceRmb = this.saveData.reformPriceRmb + 0;
                                    } else {
                                        this.saveData.reformPriceRmb = 0;
                                    }
                                }
                            }
                        }
                    }
                    if(this.saveData.specificId){
                        var index = this.saveData.specificId.indexOf("0");
                    }
                    if(index == -1){
                        this.saveData.flag = true;
                        this.saveData.specificType = '1';
                    }else{
                        this.saveData.flag = false;
                        this.saveData.specificType = '2';
                    }
                }
                this.$forceUpdate()
            },
            changes(v) {
                if (this.saveData.isSpecific == 1) {
                    this.saveData.specific = '';
                    this.saveData.specificReq = '';
                    this.saveData.specificId = '';
                    this.saveData.specificType = '1';
                    this.saveData.specificReform = '';
                    this.saveData.reformPriceRmb = '';
                    this.disabledOther = false;
                    this.saveData.isOther = null;
                    this.saveData.otherNumber = 0;
                    this.saveData.useOtherData = [];
                    this.OtherTable = [];
                    this.saveData.useData = [];
                    this.saveData.useMeg = null;
                    this.ycTable = [];
                    this.saveData.isReformStock = null
                }else {
                    this.isYPdisabled = false;
                    this.saveData.isScheduling = null;
                    this.saveData.ypIds = null;
                    this.saveData.preId = null;
                    this.ybTable = [];
                }
                this.$forceUpdate();
            },
            addUseId(v) {
                // console.log("预测，",this.saveData.useData)
                this.saveData.useId='';
                this.ycTable = [];
                var list = [];
                var obj= {
                    proCode: this.saveData.proCode
                }
                ss.waixiao.checkSelectStock(obj).then(rd => {
                    list = rd;
                    if (this.saveData.useData && this.saveData.useData.length != 0 && this.saveData.uids && this.saveData.uids.length != 0) {
                        for (var i = 0; i < this.saveData.useData.length; i++) {
                            for (var j = 0; j < this.saveData.uids.length; j++) {
                                if (this.saveData.useData[i] == this.saveData.uids[j].name) {
                                    if (this.saveData.useId != null && this.saveData.useId != '') {
                                        this.saveData.useId = this.saveData.useId + this.saveData.uids[j].code + ","
                                    } else {
                                        this.saveData.useId = this.saveData.uids[j].code + ","
                                    }
                                }
                            }
                            for(var t=0;t<list.length;t++){
                                if(list[t].id == this.saveData.useData[i]){
                                    this.ycTable.push(list[t]);
                                }
                            }
                        }
                    }
                    this.$forceUpdate();
                })
            },
            addUseIdOther(v) {
                // console.log("预测，",this.saveData.useData)
                this.saveData.otherUseId='';
                this.OtherTable = [];
                var list = [];
                var obj= {
                    proCode: this.saveData.proCode
                }
                ss.waixiao.checkSelectStockOther(obj).then(rd => {
                    list = rd;
                    if (this.saveData.useOtherData && this.saveData.useOtherData.length != 0 && this.saveData.otherUseIds && this.saveData.otherUseIds.length != 0) {
                        if(this.saveData.useOtherData.length > 1){
                            return this.$msg.msge("只能选择一个他人预测");
                        }
                        for (var i = 0; i < this.saveData.useOtherData.length; i++) {
                            for (var j = 0; j < this.saveData.otherUseIds.length; j++) {
                                if (this.saveData.useOtherData[i] == this.saveData.otherUseIds[j].name) {
                                    if (this.saveData.otherUseId != null && this.saveData.otherUseId != '') {
                                        this.saveData.otherUseId = this.saveData.otherUseId + this.saveData.otherUseIds[j].code + ","
                                    } else {
                                        this.saveData.otherUseId = this.saveData.otherUseIds[j].code + ","
                                    }
                                }
                            }
                            for(var t=0;t<list.length;t++){
                                if(list[t].id == this.saveData.useOtherData[i]){
                                    this.OtherTable.push(list[t]);
                                }
                            }
                        }
                    }
                    this.$forceUpdate()
                })
            },
            decide() {
                if (this.saveData.productModel != this.items.proModel && this.saveData.productCode != this.items.proCode) {
                    this.items.proModel = this.saveData.productModel;
                    this.items.proCode = this.saveData.productCode;
                    this.items.describe = [];
                    this.items.specificReq = [];
                    this.items.uids = [];
                    this.items.useData = [];
                    this.items.specific = [];
                    this.items.specificReform = '';
                    this.items.reformPriceRmb = '';
                }
                ss.waixiao.selectProType(this.items.proCode, 2).then(rd => {
                    this.saveData.protype = rd;
                    // if(rd = 'OEM'){
                    //     this.saveData.deliveryMethod = '2';
                    // }
                })
                // var form = {}
                // form.country = this.saveData.country;
                // form.proCode = this.saveData.productCode;
                // form.proModel = this.saveData.productModel;
                // this.getYPlist(form);
                // this.selectDingzhi(this.items);
                // this.selectStock(this.items);
                // this.selectStockOther(this.items);
            },
            getYPlist(data){
                this.saveData.ypIds = [];
                if(this.saveData.preId && this.saveData.preId !=null){
                    this.saveData.ypIds = this.saveData.preId.split(",");
                }
                this.getypData=[];
                ss.waixiao.selectPreList(data).then(rd => {
                    this.getypData = rd;
                    this.getYbTable();
                })
            },
            getOtherYPlist(data){
                this.ybTable = [];
                this.saveData.ypIds = [];
                if(this.saveData.preId && this.saveData.preId !=null){
                    this.saveData.ypIds = this.saveData.preId.split(",");
                }
                this.getypData=[];
                ss.waixiao.selectOtherPreList(data).then(rd => {
                    this.getypData = rd;
                    this.getYbTable();
                })
            },
            selectStock(v) {
                this.ycList = [];
                this.saveData.uids = [];
                var obj= {
                    proCode: this.saveData.proCode
                }
                ss.waixiao.selectStock(obj).then(rd => {
                    if (rd && rd.length > 0) {
                        this.ycList = rd;
                        for (var i = 0; i < rd.length; i++) {
                            this.saveData.uids.push({
                                code: rd[i].id,
                                name: rd[i].strDes,
                            });
                        }
                    }
                    if(this.saveData.useMeg == "" || this.saveData.useMeg == null || !this.saveData.useMeg){
                        this.saveData.useData = [];
                    }else {
                        this.saveData.useData = this.saveData.useMeg.split(",");
                    }
                    this.addUseId();

                })
            },
            selectStockOther(v) {
                this.saveData.otherUseIds = [];
                this.getOtherData=[];
                var obj= {
                    proCode: this.saveData.proCode
                }
                if(this.isCheck){
                    ss.waixiao.selectStockOtherIsCheck(obj).then(rd => {
                        if (rd && rd.length > 0) {
                            this.getOtherData = rd;
                            for (var i = 0; i < rd.length; i++) {
                                this.saveData.otherUseIds.push({
                                    code: rd[i].id,
                                    name: rd[i].strDes,
                                });
                            }
                            if(this.saveData.otherUseId == "" || this.saveData.otherUseId == null || !this.saveData.otherUseId){
                                this.saveData.useOtherData = [];
                            }else {
                                this.saveData.useOtherData = this.saveData.otherUseId.split(",");
                            }
                            this.addUseIdOther();
                        }
                    })
                }else {
                    ss.waixiao.selectStockOther(obj).then(rd => {
                        if (rd && rd.length > 0) {
                            this.getOtherData = rd;
                            for (var i = 0; i < rd.length; i++) {
                                this.saveData.otherUseIds.push({
                                    code: rd[i].id,
                                    name: rd[i].strDes,
                                });
                            }
                            if(this.saveData.otherUseId == "" || this.saveData.otherUseId == null || !this.saveData.otherUseId){
                                this.saveData.useOtherData = [];
                            }else {
                                this.saveData.useOtherData = this.saveData.otherUseId.split(",");
                            }
                            this.addUseIdOther();
                        }
                    })
                }
            },
            isYp(a){
                var form = {}
                form.country = this.saveData.country;
                form.proCode = this.saveData.productCode;
                form.proModel = this.saveData.productModel;
                if(a == 2 || a == '2'){
                    this.saveData.preId = null;
                }
                // if(this.saveData.isScheduling && this.saveData.isScheduling =='1' && a != 1){
                //     this.getYPlist(form)
                // }else if (this.saveData.isScheduling && this.saveData.isScheduling =='2' && a != 1){
                //     this.getOtherYPlist(form)
                // }
                if(this.saveData.isOther && this.saveData.isOther == '1' && a == 1){
                    this.saveData.useOtherData = [];
                    this.OtherTable = [];
                }else if (this.saveData.isOther && this.saveData.isOther == '2' && a == 1){
                    this.saveData.useData = [];
                    this.ycTable = [];
                }else {
                    this.saveData.useData = [];
                    this.ycTable = [];
                    this.saveData.useOtherData = [];
                    this.OtherTable = [];
                    this.getYPlist(form)
                }
                if(a != 1 || a != '1'){
                    this.selectCode();
                }
            },
            dataFilter(val){
                val = val.replace(/\s*/g, "");
                this.productCode = val;
                if (val) { //val存在
                    this.pCode = this.pCodecopy.filter((item) => {
                        if (!!~item.indexOf(val) || !!~item.toUpperCase().indexOf(val.toUpperCase())) {
                            return true
                        }
                    })
                } else { //val为空时，还原数组
                    this.pCode = this.pCodecopy;
                }
            },
            selectCode(v) {
                for (var key in this.items.prolist) {
                    if (this.saveData.productCode == key) {
                        this.saveData.productModel = this.items.prolist[key];
                    }
                }

                if(v == 1){
                    this.ybTable = [];
                    this.getypData=[];
                    this.ycList = [];
                    this.saveData.uids = [];
                    this.saveData.useData = [];
                    this.saveData.useMeg = ''
                    this.ycTable = [];
                    this.OtherTable = [];
                    this.saveData.ypIds = [];
                    this.saveData.otherUseIds = [];
                    this.getOtherData=[];
                    this.saveData.useOtherData = [];
                }
                this.decide();

            },
            clickmodel1() {
                this.saveData.isReformStock = null;
                // this.saveData.isShipDate = '';
                // this.saveData.shippingDate = '';
                this.saveData.proModel = '';
                this.saveData.proCode = '';
                this.saveData.protype = '';
                this.saveData.proNumber = 0;
                this.saveData.useId = '';
                this.saveData.useMeg = '';
                this.saveData.isSpecific = '';
                this.saveData.specificReform = '';
                this.saveData.specificReq = '';
                this.saveData.specific = '';
                this.saveData.reformPriceRmb = '';
                this.saveData.specificType = '1';
                this.saveData.useData = [];
                this.saveData.uids = [];
                this.saveData.prolist = [];
                this.saveData.modelOpt = [];
                this.saveData.codeOpt = [];
                this.saveData.remark = '';
                this.saveData.deliveryDate = null;
                if (this.saveData.country && this.saveData.country != '') {
                    this.f.productModel = this.saveData.proModel;
                    this.f.productCode = this.saveData.proCode;
                    this.items = this.saveData;
                    if (this.saveData.codeOpt.length == 0 || this.saveData.modelOpt.length == 0) {
                        var guojia = '';
                        var guoj = this.$store.getters.dictlist("YLCountry_agent");
                        for (var i = 0; i < guoj.length; i++) {
                            if (guoj[i].name == this.saveData.country) {
                                guojia = guoj[i].code;
                            }
                        }
                        if (!guojia || guojia == '') {
                            guojia = this.saveData.country;
                        }
                        var m = {
                            country: guojia
                        }
                        ss.waixiao.showProduct(m).then(rd => {
                            this.saveData.prolist = rd;
                            for (var key in rd) {
                                this.saveData.modelOpt.push(rd[key]);
                                this.saveData.codeOpt.push(key);
                            }
                            this.pModel = this.saveData.modelOpt;
                            this.pCode = this.saveData.codeOpt;
                            this.pCodecopy = this.saveData.codeOpt;
                            this.disabled = false;
                        })
                    } else {
                        this.pModel = this.saveData.modelOpt;
                        this.pCode = this.saveData.codeOpt;
                        this.pCodecopy = this.saveData.codeOpt;
                        this.disabled = false;
                    }
                } else {
                    this.$msg.msge("请先选择国家！");
                }
            },
            clickmodel(data) {
                console.log("datatatatattat",data)
                this.saveData= data;
                console.log("saveDatasaveDatasaveData",this.saveData)
                // if(data.otherNumber>0){
                //     this.saveData.otherNumber=data.otherNumber;
                // }else {
                //     this.saveData.otherNumber='';
                // }
                // if(data.oneNumber>0){
                //     this.saveData.oneNumber=data.oneNumber;
                // }else {
                //     this.saveData.oneNumber='';
                // }
                // if(data.ypNumber>0){
                //     this.saveData.ypNumber=data.ypNumber;
                // }else {
                //     this.saveData.ypNumber='';
                // }
                // this.saveData.deliveryMethod= data.deliveryMethod.toString();
                if(this.saveData.deliveryMethod || this.saveData.deliveryMethod==0){
                    this.saveData.deliveryMethod = this.saveData.deliveryMethod.toString()
                }
                if(this.saveData.isScheduling || this.saveData.isScheduling==0){
                    this.saveData.isScheduling = this.saveData.isScheduling.toString()
                }
                if(this.saveData.isOther || this.saveData.isOther==0){
                    this.saveData.isOther = this.saveData.isOther.toString()
                }
                if(this.saveData.isReal || this.saveData.isReal==0){
                    this.saveData.isReal = this.saveData.isReal.toString()
                }
                if(this.saveData.isStandard || this.saveData.isStandard==1 || this.saveData.isStandard==2){
                    this.saveData.isStandard = this.saveData.isStandard.toString()
                }
                this.saveData.productCode =  this.saveData.proCode;
                this.saveData.productModel =  this.saveData.proModel;
                // this.saveData.otherUseIds=[];
                this.saveData.modelOpt = [];
                this.saveData.codeOpt = [];
                this.saveData.uids = [];
                this.saveData.useData = [];
                this.saveData.ypIds = [];
/*                if(this.saveData.otherUseId && this.saveData.otherUseId.length > 3){
                    this.saveData.useOtherData = this.saveData.otherUseId.split(",");
                }*/
                if(this.saveData.specificReq && this.saveData.specificReq.length > 3){
                    this.saveData.specific = this.saveData.specificReq.split(",");
                }
                if (this.saveData.country && this.saveData.country != '') {
                    this.f.productModel = this.saveData.proModel;
                    this.f.productCode = this.saveData.proCode;
                    this.items = this.saveData;
                    if (this.saveData.codeOpt.length == 0 || this.saveData.modelOpt.length == 0) {
                        var guojia = '';
                        var guoj = this.$store.getters.dictlist("YLCountry_agent");
                        for (var i = 0; i < guoj.length; i++) {
                            if (guoj[i].name == this.saveData.country) {
                                guojia = guoj[i].code;
                            }
                        }
                        if (!guojia || guojia == '') {
                            guojia = this.saveData.country;
                        }
                        var m = {
                            country: guojia
                        }
                        ss.waixiao.showProduct(m).then(rd => {
                            this.saveData.prolist = rd;
                            for (var key in rd) {
                                this.saveData.modelOpt.push(key);
                                this.saveData.codeOpt.push(rd[key]);
                            }
                            this.pModel = this.saveData.modelOpt;
                            this.pCode = this.saveData.codeOpt;
                            this.pCodecopy = this.saveData.codeOpt;
                            this.disabled = false;
                        })
                    } else {
                        this.pModel = this.saveData.modelOpt;
                        this.pCode = this.saveData.codeOpt;
                        this.pCodecopy = this.saveData.codeOpt;
                        this.disabled = false;
                    }
                    ///物料工位
                    this.saveData.stationlist = this.saveData.materialStation? this.saveData.materialStation.split(","): [];
                    //个性化定制标准描述
                    this.saveData.individualizeList = this.saveData.individualizeReform? this.saveData.individualizeReform.split("##"): [''];
                    //包装标识要求
                    this.saveData.logoRequestList = this.saveData.logoRequest? this.saveData.logoRequest.split("##"): [''];

                    if(this.saveData.reformMainDetailList){
                        this.showSpecifictDetail = true;
                    }else {
                        this.showSpecifictDetail = false;
                    }

                    // this.addspecificId();
                    this.isYp();
                }
            },
            showCountry(data) {
                var country = this.$store.getters.dictlist("YLCountry_agent");
/*                ss.waixiao.selectCountry().then(rd => {
                    for (var i = 0; i < rd.length; i++) {
                        for (var j = 0; j < country.length; j++) {
                            if (country[j].code == rd[i]) {
                                this.gjCo.push(country[j].name);
                            }
                            if(country[j].code == data.country){
                                data.country = country[j].name;
                            }
                        }
                    }
                    this.clickmodel(data)
                })*/
                this.clickmodel(data)
            },
            showArea() {
                ss.waixiao.getArea().then(rd => {
                    this.areaList = rd;
                    // this.saveData.area = rd[0].qycode;
                })
            },
            query(data) {
                this.q.id = this.$route.query.ywid;
                ss.waixiao.showPage(this.q).then(rd => {
                    this.showCountry(rd.records[0]);
                    // this.showArea();
                    // this.clickmodel(rd.records[0]);
                    if(rd != null){
                        this.isCheck = true;
                    }
                    if(this.saveData.specificList){
                        this.newFlag = true;
                    }else {
                        this.newFlag = false;
                    }
                })
            },
            //返回
            backS1() {
                this.$router.go(-2)
            },
            //返回
            backS() {
                this.$router.push({path: "/yuce/wxxiangqing"});
            },
            inputOnMouseOver(event){
                const target=event.target
                if(target.offsetWidth<target.scrollWidth){
                    this.isshowtip=false
                }else{
                    this.isshowtip=true
                }
            },
        }
    }
</script>
<style scoped>
    /*--------------- 审批样式 ----------------*/
    .h1{
        margin: 20px 0 0 31px;
    }
    .bbbb{
        background-color: white;
    }
    .apprButton {
        display: flex;
        justify-content: center;
        align-items: center;
        width: 100%;
        padding: 0.3rem 0;
    }
    .cancel {
        width: 18%;
    }
    .pass {
        background-color: #006aca;
        color: white;
        width: 18%;
    }
    .refuse {
        background-color: #24b5b8;
        color: white;
        width: 18%;
    }
    /*--------------- 审批样式 ------------------*/
</style>
<style>
    .wxshenhe .h-formbLine .h-elformWrap-2{
        width: 33.33%;
    }
    .wxshenhe .h-formbLine .el-form-item__label{
        width: 38%;
    }
    .wxshenhe .h-formbLine .el-form-item__content{
        width: 62%;
    }
    .ljjtablepaddings6 .h-tableInput .el-input__inner{
        padding: 0.05rem 0.1rem;
    }
    .ljjtablepaddings6 .h-tableInput .el-input__icon{
        line-height: 0.25rem;
    }
    .Yangbiao .h-elformWrap-2 .el-form-item__label {
        width: 45%;
        text-align: right;
    }

    .Yangbiao .el-form-item__content {
        width: 55%;
    }

    .Yangbiao .h-elformWrap-2 {
        width: 25% !important;
        padding-right: 0.5rem
    }
    .Yangbiao .h-elformWrap-5 {
        width: 74% !important;
        padding-right: 0.5rem
    }


    .Yangbiao .h-elformWrap-3 {
        width: 85% !important;
        padding-right: 0.5rem
    }
    .Yangbiao .h-elformWrap-3 .el-form-item__label {
        width: 12%;
        text-align: right;
    }
    .Yangbiao .h-elformWrap-35 {
        width: 77% !important;
        padding-right: 0.5rem
    }
    .Yangbiao .h-elformWrap-35 .el-form-item__label {
        width: 20%;
        text-align: right;
    }
    .Yangbiao .h-elformWrap-4 {
        width: 100%;
        padding-right: 0.5rem
    }

    .Yangbiao .h-elformWrap-4 .el-form-item__label {
        width: 10%;
    }
    .Yangbiao .h-elformWrap-4 .el-form-item__content {
        width: 89%;
    }
    .Yangbiao .w-elformWrap {
        width: 100% !important;
    }
    .w-elformWrap .el-form-item__label {
        width: 14% !important;
    }
    .w-elformWrap .el-form-item__content {
        width: 86% !important;
    }
    .Yangbiao .h-elformWrap-1 {
        width: 100%;
        padding-right: 0.5rem
    }

    .Yangbiao .h-elformWrap-1 .el-form-item__label {
        width: 14%;
    }

    .Yangbiao .h-elformWrap-1 .el-form-item__content {
        width: 86%;
    }

    .Yangbiao.el-form-item__content .el-select {
        width: 100%;
    }

    .ljjtablepaddings6 .h-tableInput .el-input__inner{
        padding: 0.05rem 0.1rem;
    }
    .ljjtablepaddings6 .h-tableInput .el-input__icon{
        line-height: 0.25rem;
    }
    .bbbb {
        padding-top: 5px;
        margin: 0 20px;
    }

    .hang {
        padding: 20px 0;
        margin-bottom: 0;
        background-color: white;
    }
    .ddform_disable_cls .el-form-item__content .el-input__inner[disabled] {
        color: #868686;
    }

</style>
